/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {PackageItemCompetition} from "types/entities/PackageItem";
import {currencyNumberFormat} from "utils/utility";

import {isCompetitionInGroups, useCompetitions} from "utils/hooks/useCompetitions";

interface CompetitionPriceProps {
    competition: PackageItemCompetition;
    className?: string;
}

const CompetitionPrice = (props: CompetitionPriceProps) => {
    const {t} = useTranslation();
    const {freeSelectCompetitions} = useCompetitions();

    const isFree = isCompetitionInGroups(freeSelectCompetitions, props.competition);

    // competitions included in the package are free of charge
    if (isFree) {
        return null;
    }

    return (
        <div className={clsx("CompetitionPrice flex flex-col items-start sm:items-end shrink-0 text-black", props.className)}>
            <b className={"text-sm md:text-base font-bold leading-tight whitespace-nowrap"}>{currencyNumberFormat(props.competition.price)}</b>
            {props.competition.extra.whole_group && <small className={"text-xs font-medium text-black/60"}>{t("whole group")}</small>}
        </div>
    );
};

export default CompetitionPrice;
